import React from 'react';
import styled from 'styled-components';

const StyledKbd = styled.kbd`
  padding:2px 6px;
  margin:4px;
  border-radius: 4px;
  background: var(--color-gray3);
  color: var(--color-headingFont);
  box-shadow: 1px 2px 0px var(--color-primary);
`;


const Kbd = (props) => {
  return <StyledKbd {...props} />
}
export default Kbd;